import React, { useMemo } from "react";

import { AppBar, Box, Paper } from "@material-ui/core";
import * as R from "ramda";
import { useNavigate, useParams } from "react-router";

import BusinessHeader from "components/BusinessHeader";
import MenuGroupSelector from "components/MenuGroupSelector";
import SelectorChip from "components/SelectorChip";
import MenuDrawer from "containers/MenuDrawer";
import OrderTypeDrawer from "containers/OrderTypeDrawer";

import MenuContext from "contexts/MenuContext";

import makeStyles from "hooks/makeStyles";
import useCart from "hooks/useCart";
import useLocalize from "hooks/useLocalize";
import useMenus from "hooks/useMenus";

import ReadyTimeMessage from "../../OrderTypeDrawer/ReadyTimeMessage";

import BottomDrawers from "../BottomDrawers";
import Menu from "../Menu";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		flexDirection: "row"
	},
	header: {
		elevation: 0,
		backgroundColor: theme.palette.background.default,
		// backgroundColor: "transparent",
		justifyContent: "center",
		color: theme.palette.text.primary,
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),
		padding: 0
	},
	headerContent: {
		backgroundColor: theme.palette.background.default,
		// backgroundColor: "transparent",
		padding: theme.spacing(2),
		paddingBottom: theme.spacing(1)
	},
	selectors: {
		display: "flex",
		flex: 1,
		flexDirection: "row",
		marginTop: theme.spacing(1)
	},
	menusSelector: {
		marginRight: theme.spacing(2)
	},
	menuGroupSelector: {
		marginTop: 2,
		width: "100vw"
	},
	orderTypeSelector: {
		flex: 1,
		justifyContent: "space-between"
	},
	orderTypeSelectorLabel: {
		flex: 1,
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "baseline"
	},
	orderTypeSelectorLabelHint: {
		fontWeight: "normal"
	},
	menuContainer: {
		backgroundColor: theme.palette.background.default,
		position: "relative",
		// height: "100vh",
		display: "flex",
		flexDirection: "column",
		// flex: 1,
		paddingTop: theme.mobileBusinessHeaderHeight,
		margin: 0,
		padding: 0,
		overflow: "hidden"
	}
}));

const MenuScreenBodyMobile = () => {
	const navigate = useNavigate();
	const params = useParams();
	const classes = useStyles();

	const { localize } = useLocalize();

	const { menus } = useMenus();
	const { orderType } = useCart();

	const menu = (params.menuSlug && menus.find(x => x.slug === params.menuSlug)) || menus[0];

	const menuContext = useMemo(
		() => ({
			menu,
			menuGroupBySlug: R.fromPairs(menu.menuGroups.map(x => [x.slug, x])),
			menuItemById: R.fromPairs(R.flatten(menu.menuGroups.map(x => x.menuItems)).map(x => [x.id, x]))
		}),
		[menu]
	);

	return (
		<>
			<MenuDrawer selectedMenuSlug={menu ? menu.slug : null} />
			<OrderTypeDrawer />
			<Box className={classes.root}>
				<Box className={classes.menuContainer}>
					<MenuContext.Provider value={menuContext}>
						<Menu />
						<AppBar position="fixed" className={classes.header} elevation={0}>
							<Paper className={classes.headerContent} elevation={2} variant="elevation" square>
								<BusinessHeader isReceiptMode={false} />

								<Box component="div" className={classes.selectors}>
									{/* <SelectorChip className={classes.menusSelector} label={localize(menu.localeNames, menu.name)} onClick={() => navigate("#menu?")} /> */}

									<SelectorChip
										className={classes.orderTypeSelector}
										classes={{ label: classes.orderTypeSelectorLabel }}
										label={
											<>
												<span>{localize(orderType?.localeNames, orderType?.name || "")}</span>
												<ReadyTimeMessage />
											</>
										}
										onClick={() => navigate("#order-type?")}
									/>
								</Box>
							</Paper>
							<MenuGroupSelector className={classes.menuGroupSelector} menuGroups={menu.menuGroups} />
						</AppBar>
						<BottomDrawers />
					</MenuContext.Provider>
				</Box>
			</Box>
		</>
	);
};

export default MenuScreenBodyMobile;
